'use client';

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@repo/ui';
import { Container } from '@repo/web-chrome/components/container';
import { Heading, Subheading } from '@repo/web-chrome/components/text';
import type { IFaqItem } from '@/content/faq';

interface IFaqAccordionProps {
  eyebrow?: string;
  heading?: string;
  items: IFaqItem[];
}

export function FaqAccordion({
  eyebrow = 'Questions',
  heading = 'Things people ask first.',
  items,
}: IFaqAccordionProps): React.JSX.Element {
  return (
    <Container className="py-24 sm:py-32">
      <div data-reveal="up" className="mx-auto max-w-3xl">
        {eyebrow && <Subheading className="text-center">{eyebrow}</Subheading>}
        <Heading as="h2" className="mt-2 text-center">
          {heading}
        </Heading>
        <Accordion
          type="single"
          collapsible
          className="mt-12 rounded-2xl bg-card px-6 ring-1 ring-foreground/10"
        >
          {items.map((item) => (
            <AccordionItem
              key={item.question}
              value={item.question}
              className="transition-colors data-[state=open]:bg-foreground/[0.02]"
            >
              <AccordionTrigger className="text-base font-medium text-foreground">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-base text-muted-foreground">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </Container>
  );
}
